export enum ErrorKind {
  NOT_FOUND = 'not_found',
  TOO_MANY_REQUESTS = 'too_many_requests',
  VALIDATION_ERROR = 'validation_error',
  ALREADY_EXISTS = 'already_exists',
  PAYMENT_API_KEY_INVALID = 'payment_api_key_invalid',
  CAPTCHA_INVALID = 'captcha_invalid',
  LINK_DEPLETED = 'link_depleted',
  INACTIVE = 'inactive',
  RANGE_EXCEEDED = 'range_exceeded',
  MAXIMUM_QUANTITY_HAS_BEEN_REACHED = 'maximum_quantity_has_been_reached',
  REQUIRED = 'required',
  INSTAGRAM_PAGE_ID_NOT_FOUND = 'instagram_page_id_not_found',
  RESEARCH_GROUP_FINISHED = 'research_group_finished',
  ALREADY_EXISTS_USER = 'already_exists_user',
  // error.info.kind, not error.type: a forgot_token that was used, rotated or swept, and one still on
  // the account but past its window. Both mean the link is dead and a new one has to be asked for.
  TOKEN_INVALID = 'token_invalid',
  TOKEN_EXPIRED = 'token_expired',
  // Two prices on one product may not share a start time: nothing can order them, so which one
  // the shop charges falls to the order the rows come back in (PAUL-3469).
  PRODUCT_PRICE_AVAILABLE_FROM_DUPLICATE = 'product_price_available_from_duplicate',
}
